"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideo = void 0;
var tslib_1 = require("tslib");
var video_1 = require("../../../private/services/video/video");
var public_catalog_service_1 = require("../../../catalog-services/public-catalog-service");
/**
 * Public service for working with Video entity
 * @doc PublicVideo
 */
var PublicVideo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PublicVideo, _super);
    function PublicVideo() {
        var _this = _super.call(this) || this;
        _this.privateVideo = new video_1.PrivateVideo();
        return _this;
    }
    /**
     * Get download link for video
     * @param {string} baseUrl
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instance
     * @example
     *
     * const {videoId, channelId} = this.props;
     * const instance = Wix.Utils.getInstance();
     *
     * return (
     *   <div>
     *     Your download url is: {PublicVideo.getDownloadUrl(videoId, channelId, instance)}
     *   </div>
     * );
     */
    PublicVideo.getDownloadUrl = function (baseUrl, videoId, channelId, instance) {
        return "".concat(baseUrl, "/public/download/").concat(videoId, "/redirect?instance=").concat(instance, "&channel_id=").concat(channelId);
    };
    /**
     * Fetch video entity by videoId
     * @param {string} videoId
     * @param {RequestOptions} requestConfig
     * @example
     *
     * const video = await new PublicVideo()
     *  .getById('here-could-have-been-your-video-id')
     *  .then(response => response.data)
     */
    PublicVideo.prototype.getById = function (videoId, requestConfig) {
        return this.privateVideo.getById(videoId, requestConfig);
    };
    /**
     * Get urls to video files for given videoId.
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instance
     * @param {RequestOptions} requestConfig
     * @example
     *
     * const videoUrls = await new PublicVideo()
     *  .getVideoUrls('video-id')
     *  .then(response => response.data);
     */
    PublicVideo.prototype.getVideoUrls = function (videoId, channelId, instance, requestConfig) {
        return this.httpClient.get("/public/play/".concat(videoId), (0, tslib_1.__assign)({ params: {
                instance: instance,
                channel_id: channelId,
            } }, requestConfig));
    };
    return PublicVideo;
}(public_catalog_service_1.PublicCatalogService));
exports.PublicVideo = PublicVideo;
//# sourceMappingURL=video.js.map